import React from 'react';
import styled from 'styled-components';
import EduzinhoImg from '@/assets/images/eduPerson.png';

interface Props {
  score: number;        // 0 ≤ score ≤ 10
  title?: string;       // Optional title
}

// Wrapper to position title, legend, and thermometer
const Container = styled.div`
  position: relative;
  width: 100%;
  padding-top: 80px; /* space for title and legend */
`;

// Title at top-left
const Title = styled.h3`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  font-size: 16px;
  color: #333;
`;

// Legend container at top-right
const LegendContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 16px;
  align-items: center;
`;

// Individual legend item
const LegendItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
`;

// Colored dot
const LegendDot = styled.span<{ bg: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.bg};
  border-radius: 50%;
  margin-right: 4px;
`;

export const ThermoBar = styled.div`
  position: relative;
  width: 100%;
  height: 30px;
  border-radius: 16px;
  background: linear-gradient(
    to right,
    #e74c3c 0%,
    #e74c3c 33.33%,
    #f1c40f 33.33%,
    #f1c40f 66.67%,
    #2ecc71 66.67%,
    #2ecc71 100%
  );
`;

const IndicatorLine = styled.div<{ leftPercent: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => props.leftPercent}%;
  width: 2%;
  max-width: 4px;
  background: #34495e;
  transform: translateX(-50%);
`;

const IndicatorImage = styled.img<{ leftPercent: number }>`
  position: absolute;
  bottom: 100%;
  left: ${(props) => props.leftPercent}%;
  width: 60px;
  height: 60px;
  transform: translateX(-50%) translateY(-4px);
`;

const Thermometer: React.FC<Props> = ({ score, title }) => {
  const safeScore = Math.max(0, Math.min(10, score));
  let leftPercent: number;

  // map [0-4] → [0-33.33], [4-8] → [33.33-66.67], [8-10] → [66.67-100]
  if (safeScore < 4) {
    leftPercent = (safeScore / 4) * 33.33;
  } else if (safeScore < 8) {
    leftPercent = ((safeScore - 4) / 4) * 33.33 + 33.33;
  } else {
    leftPercent = ((safeScore - 8) / 2) * 33.33 + 66.67;
  }

  return (
    <Container>
      {title && <Title>{title}</Title>}
      <LegendContainer>
        <LegendItem>
          <LegendDot bg="#e74c3c" /> Score baixo
        </LegendItem>
        <LegendItem>
          <LegendDot bg="#f1c40f" /> Score intermediário
        </LegendItem>
        <LegendItem>
          <LegendDot bg="#2ecc71" /> Score alto
        </LegendItem>
      </LegendContainer>
      <ThermoBar>
        <IndicatorLine leftPercent={leftPercent} />
        <IndicatorImage src={EduzinhoImg} leftPercent={leftPercent} alt="indicator" />
      </ThermoBar>
    </Container>
  );
};

export default Thermometer;
